<template>
  <div class="shared-link-create-dialog-box">

    <shared-link-copy-dialog-box
      :file-name="fileName"
      :link-id="getSharedLink.linkId"
      :link-url="getSharedLink.link"
      :creation-date="getSharedLink.creationDate"
      :is-in-progress="isCreationSharedLinkInProgress"
      @close="onClose"
      @settings="onLinkSettings"
    />

  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import {
  CREATE_SHARED_LINK
} from '../store/action-types';

import {
  PENDING_STATUS
} from '../store/action-status';

import SharedLinkCopyDialogBox from './SharedLinkCopyDialogBox';

const { mapGetters, mapActions } = createNamespacedHelpers('wre-dashboard');

export default {
  name: 'SharedLinkCreateDialogBox',
  components: {
    SharedLinkCopyDialogBox
  },
  props: {
    archiveId: {
      type: String,
      default: '',
      required: true
    },
    fileName: {
      type: String,
      default: '',
      required: true
    },
    path: {
      type: String,
      default: '',
      required: true
    },
    fileVersion: {
      type: Number,
      default: 0,
      required: false
    },
    isFolder: {
      type: Boolean,
      default: false,
      required: false
    },
    isInProgress: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters([
      'getSharedLink',
      'getCreateSharedLinkStatus'
    ]),
    isCreationSharedLinkInProgress() {
      return this.getCreateSharedLinkStatus === PENDING_STATUS || this.isInProgress;
    }
  },
  methods: {
    ...mapActions({
      createSharedLink: CREATE_SHARED_LINK
    }),
    onLinkSettings(linkId) {
      this.$emit('handleLinkSettings', linkId);
    },
    onClose() {
      this.$emit('handleClose');
    },
    createOrGetSharedLink() {
      this.createSharedLink({
        archiveId: this.archiveId,
        path: this.isFolder ? `${this.path}/` : this.path,
        fileVersion: this.fileVersion
      });
    }
  },
  mounted() {
    this.createOrGetSharedLink();
  }
};
</script>

<style lang="scss" scoped>
  .lighter-text {
    color: $av-fixed-lighter;
  }
</style>
